import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * AUT-542 — footer of a `/config` form: an optional left slot («Править
 * как JSON»), «Отмена», «Сохранить», and the server error under the form.
 */
export interface ConfigFormFooterProps {
  canSave: boolean;
  busy: boolean;
  error?: string | undefined;
  onSave: () => void;
  onCancel: () => void;
  start?: ReactNode;
}

export const ConfigFormFooter = ({
  canSave,
  busy,
  error,
  onSave,
  onCancel,
  start,
}: ConfigFormFooterProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pt: 1.5,
          mt: 1.5,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box sx={{ mr: 'auto' }}>{start}</Box>
        <Button variant="outlined" onClick={onCancel} disabled={busy}>
          {t('common.cancel')}
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={busy || !canSave}
          data-testid="sm-config-save"
        >
          {t('common.save')}
        </Button>
      </Box>
      {error ? (
        <Alert severity="error" sx={{ mt: 1.5 }}>
          {error}
        </Alert>
      ) : null}
    </>
  );
};
